<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="wrapper">
      <div class="container">
        <notice-editor :language="localization.TH" v-model="form"></notice-editor>
        <div class="text-right mt-4">
          <sc-button variant="primary" @click="handleClickSave"
            >บันทึก</sc-button
          >
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import NoticeEditor from "../components/NoticeEditor";
import { baanRueJaiClient } from "@/dependencies";
import { localization } from "@/lib/mapper";
import { uploadImage } from "@/god";
import { DateTime } from "luxon";

export default {
  components: {
    PageWrapper,
    ScButton,
    NoticeEditor
  },
  data() {
    const title = "เพิ่มประกาศ";
    const form = {
      title: "",
      subtitle: "",
      projects: [],
      publishDate: null,
      calendarDate: null
    };

    return {
      localization,
      title,
      form
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {},
    async handleClickSave() {
      try {
        await this.createNotice();
        this.$router.push({ name: "NoticeListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async createNotice() {
      const { title, projects, subtitle, publishDate, calendarDate} = this.form;

      if (title === "" || !projects.length || !publishDate) {
        alert("กรุณากรอกข้อมูลให้ครบ");

        reject();
      }

      const projectIds = projects.map(({ projectId }) => projectId);

      const params = {
        title,
        subtitle,
        projectIds,
        publishDate: {
          start: publishDate.start.toISO(),
          end: publishDate.end.toISO()
        },
        calendarDate: (calendarDate !== null) ?
          {
            start: calendarDate.start.toISO(),
            end: calendarDate.end.toISO()
          }
          : undefined
      };

      const response = await baanRueJaiClient.admin.communications.notices.post(
        params
      );

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/notices/pages/NoticeCreatePage.vue